import apiService from "./ApiService"
import { createQS } from "./Utils"

class DashboardService {
  async contrato() {
    try {
      return await apiService.get('dashboard/contrato')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async gerar(idContrato) {
    try {
      return await apiService.get(`dashboard/gerar/${idContrato}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const dashboardService = new DashboardService()
export default dashboardService